import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { DataUserService } from '../../../services/data-user/data-user.service';
import { LoginService } from '../../../services/login/login.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Meta, Title } from '@angular/platform-browser';


@Component({
  selector: 'app-logueo',
  templateUrl: './logueo.component.html',
  styleUrls: ['./logueo.component.scss'],
  standalone: false,
  providers: [MessageService]
})
export class LogueoComponent implements OnInit {

  isLoad: boolean = false;
  userExists: boolean = false;
  count: number = 0;
  form = new FormGroup({
    login: new FormControl('', [Validators.required, Validators.maxLength(25), Validators.minLength(5)]),
    password: new FormControl('', [Validators.required, Validators.maxLength(25), Validators.minLength(7)])
  });
  token: any = {};
  infoUser: any = {};
  // canal de comunicación entre pestañas
  channel = new BroadcastChannel('channelSession');

  constructor(private login: LoginService, private message: MessageService,
    private router: Router,
    private dataUser: DataUserService,
    private meta: Meta, private titleService: Title) {

    // validar bloqueo
    if (!!localStorage.getItem('bloqueo'))
      this.count = 5;
    // validar si ya esta logueado
    if (!!localStorage.getItem('token')) {
      this.infoUser = JSON.parse(localStorage.getItem('infoUser') ?? "");
      // pagina de inicio
      this.router.navigate([this.infoUser.idPerfilNavigation.pageHome]);
    }




  }

  ngOnInit(): void {
    this.titleService.setTitle('[SIMESCCO] Software de Gestión Administrativa');
    this.meta.updateTag({ name: 'description', content: 'Software que permite administrar todo lo referente a su negocio, en apoyo con nuevas tecnologías' });

    // listen Channel
    this.channel.onmessage = (event) => {
      if (event.data == 'reload') {
        window.location.reload();
      }
    }
  }



  continuar() {

    // validar el numero de intentos o si no se bloquea al usuario por 3 minutos
    if (this.count >= 5) {
      this.message.add({ key: 'message', severity: 'warning', summary: 'Información', detail: 'Usted ha sido bloquedo por tres minutos' });
      if (!localStorage.getItem('bloqueo'))
        localStorage.setItem('bloqueo', new Date().getTime().toString());
      this.validBloqueo();
    }
    else
      if (!this.userExists) {
        const data = { Login: this.form.controls.login.value }
        if (this.form.controls.login.valid) {
          this.form.controls.login.disable();
          this.isLoad = true;
          this.login.existUser(data).subscribe({
            next: (response) => {
              if (parseInt(response.toString()) == 1) {
                // usuario activo
                this.userExists = true;
              }
              else {
                // usuario Inactivo
                this.form.controls.login.enable();
                this.message.add({ key: 'message', severity: 'warn', summary: 'Error', detail: 'Usuario Inactivo' });
                this.form.controls.login.setValue('');
              }
              this.isLoad = false;
            }, error: (error: Response) => {
              // usuario no existe
              this.form.controls.login.enable();
              this.message.add({ key: 'message', severity: 'error', summary: 'Error', detail: 'Usuario no existe' });
              this.form.controls.login.setValue('');
              this.count++;
              this.isLoad = false;
            }
          })
        }
        else {
          this.count++;
          this.message.add({ key: 'message', severity: 'error', summary: 'Error', detail: 'Favor ingrese la respectiva información' });
        }
      }
      else {
        if (this.form.valid) {
          // se valida usuario y clave
          this.isLoad = true;
          const data = { Login: this.form.controls.login.value, Password: this.form.controls.password.value }
          this.login.credentials(data).subscribe({
            next: (response) => {
              this.token = response as object;
              localStorage.setItem('token', JSON.stringify(this.token));

              this.dataUser.getDataUser(this.token.token).subscribe((response) => {
                this.infoUser = response as any;
                localStorage.setItem('infoUser', JSON.stringify(this.infoUser));

                // pagina de inicio
                //this.router.navigate([this.infoUser.idPerfilNavigation.pageHome]);
                window.location.href = this.infoUser.idPerfilNavigation.pageHome;

                this.isLoad = false;
              });
              //this.router.navigate(["Begin"]);
            }, error: (error: Response) => {
              this.message.add({ key: 'message', severity: 'error', summary: 'Error', detail: 'Datos erroneos, favor intente nuevamente' });
              this.form.controls.password.setValue('');
              this.isLoad = false;
            }
          })
        }
        else {
          this.count++;
          this.message.add({ key: 'message', severity: 'error', summary: 'Error', detail: 'Favor ingrese la respectiva información' });
        }
      }

  }

  validBloqueo() {
    const dat: any = new Date(parseInt(localStorage.getItem('bloqueo') ?? "0"));
    const now: any = new Date().getTime();

    var diff = ((dat - now) / 1000);
    diff /= 60;
    if (Math.abs(Math.round(diff)) > 2) {
      this.count = 0;
      localStorage.removeItem('bloqueo');
      this.continuar();
    }
  }


}
